import React, { useContext, useEffect } from "react";
import PageHeader from "../pageheader/PageHeader";
import TextEditor from "../material/textEditor/TextEditor";
import { useLocation, useNavigate } from "react-router-dom";

import { CurrentUserContext } from "../../App";
import MenuDoctor from "./navDoctor/MenuDoctor";

export default function ViewannouncementDoctor() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log(location.state?.data);
    if (!location.state?.data) {
      setIsMessage({ type: "warning", data: "ปฏิเสธเข้าถึงข่าวประชาสัมพันธ์" });
      navigate("/doctor/home");
    }
  }, []);

  return (
    <div className="global-page">
      <MenuDoctor menuActive={"homedoctor"} />
      <PageHeader
        titlename={"ข่าวสารประชาสัมพันธ์"}
        backpath={"/doctor/home"}
        btnBackWard
      />
      <div className="ml-24 mr-24 sm:mx-8">
        <div className="text-xl text-[#2E2E2E] my-3">รายละเอียด</div>
        {location.state?.data ? (
          <>
            <TextEditor readOnly={true} value={location.state?.data} />
          </>
        ) : null}
      </div>
    </div>
  );
}
